// ============================================================
// RecentActivityCard Component
// ============================================================
// Displays a list of recent activities with icons.

import { Box, Typography, Avatar } from '@mui/material';
import { UserPlus, IndianRupee, CalendarCheck, GraduationCap } from 'lucide-react';
import { WidgetContainer } from './WidgetContainer';
import { tokens } from '@/theme/tokens';

const iconMap = {
  admission: { icon: UserPlus, color: 'primary' },
  fee: { icon: IndianRupee, color: 'success' },
  attendance: { icon: CalendarCheck, color: 'warning' },
  academic: { icon: GraduationCap, color: 'secondary' },
  staff: { icon: UserPlus, color: 'primary' },
};

export function RecentActivityCard({ activities = [] }) {
  if (activities.length === 0) {
    return (
      <WidgetContainer title="Recent Activity">
        <Typography variant="body2" color="text.secondary" sx={{ textAlign: 'center', py: 4 }}>
          No recent activities found.
        </Typography>
      </WidgetContainer>
    );
  }

  return (
    <WidgetContainer title="Recent Activity">
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        {activities.map((activity) => {
          const config = iconMap[activity.type] || iconMap.academic;
          const Icon = config.icon;
          const colorMain = tokens.colors[config.color]?.main || tokens.colors.primary.main;

          return (
            <Box key={activity.id} sx={{ display: 'flex', gap: 2, alignItems: 'flex-start' }}>
              <Avatar
                sx={{
                  bgcolor: `${colorMain}15`,
                  color: colorMain,
                  width: 40,
                  height: 40,
                }}
              >
                <Icon size={20} />
              </Avatar>
              <Box sx={{ flex: 1 }}>
                <Typography variant="subtitle2" fontWeight={600}>
                  {activity.action}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {activity.details}
                </Typography>
              </Box>
              <Typography variant="caption" color="text.secondary" sx={{ whiteSpace: 'nowrap' }}>
                {activity.time}
              </Typography>
            </Box>
          );
        })}
      </Box>
    </WidgetContainer>
  );
}
